/*
This regex pattern is meant to adhere to the RFC 5322 standard for email addresses.
This version is slightly modified from the one found here https://stackoverflow.com/questions/201323/how-can-i-validate-an-email-address-using-a-regular-expression
The modification allows for spaces within the local portion of the email provided they are enclosed by double quotes.
*/
export const emailRegex =
  // eslint-disable-next-line no-useless-escape
  /^(?:[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*|"(?:[ !#-\[\]-~]|\\[ -~])*")@(?:(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z]{2,}|(?:\[(?:(?:25[0-5]|2[0-4][0-9]|[0-1]?[0-9][0-9]?)\.){3}(?:25[0-5]|2[0-4][0-9]|[0-1]?[0-9][0-9]?)\]))$/i;
